import { render } from "./SaveClaimExpenseType.vue?vue&type=template&id=056d6518&scoped=true"
import script from "./SaveClaimExpenseType.vue?vue&type=script&lang=js"
export * from "./SaveClaimExpenseType.vue?vue&type=script&lang=js"

import "../save-claim-event.scss?vue&type=style&index=0&id=056d6518&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056d6518"]])

export default __exports__